"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerInsightsPanelItem = void 0;
var Label_1 = require("../../labels/Label");
var SettingsPanelItem_1 = require("../../settings/SettingsPanelItem");
var PlayerInsightsPanelItem = /** @class */ (function (_super) {
    __extends(PlayerInsightsPanelItem, _super);
    function PlayerInsightsPanelItem(config) {
        var _this = this;
        var _a, _b;
        var leadingLabel = new Label_1.Label({
            text: config.leadingLabel,
            cssClasses: ['ui-player-insights-panel-item-leading-label'],
        });
        var trailingLabel = new Label_1.Label({
            text: '-',
            cssClasses: ['ui-player-insights-panel-item-trailing-label'],
        });
        _this = _super.call(this, __assign(__assign({}, config), { label: null, components: __spreadArray([leadingLabel, trailingLabel], ((_a = config.components) !== null && _a !== void 0 ? _a : []), true), cssClasses: __spreadArray(['ui-player-insights-panel-item'], ((_b = config.cssClasses) !== null && _b !== void 0 ? _b : []), true), isSetting: false, role: 'group', tabIndex: -1 })) || this;
        _this.trailingLabel = trailingLabel;
        return _this;
    }
    PlayerInsightsPanelItem.prototype.setTrailingLabel = function (text) {
        this.trailingLabel.setText(text);
    };
    return PlayerInsightsPanelItem;
}(SettingsPanelItem_1.SettingsPanelItem));
exports.PlayerInsightsPanelItem = PlayerInsightsPanelItem;
